import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import AntTooltip from 'components/Common/AntTooltip';
import fa from 'locales/fa.json';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';
import { postProfileAction } from 'store/account/account.action';
import { faNumber } from 'utils/common.util';
import ChangePassword from './changePassword';
import MyComments from './myComments';
import MyCreateQuestion from './myCreatedQuestion';
import MyQuestions from './myQuestions';
import MyTraining from './myTraining';
import Scores from './scores';
import Transaction from './transaction';
import {
  InstallmentsRoute,
  ShopRoute,
  TicketRoute,
  UserConsultingRoute,
} from 'services/routes';

type UserInfoType = { setIsModalVisible: (status) => void; eventsCount: number };

const UserInfo: React.FC<UserInfoType> = ({ setIsModalVisible, eventsCount }) => {
  const user = useSelector((state) => state.account.user);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const dispatch = useDispatch();

  return (
    <div className="w-[290px] text-[14px] flex flex-col">
      <div className="flex justify-between mb-3">
        <div className="text-[14px]">{fa.global.coursesCount}</div>
        <div>{faNumber(user?.workshops.length + eventsCount)} </div>
      </div>
      <Scores />

      <div className="flex justify-between mb-3">
        <Link href={ShopRoute()}>
          <a className="hover:text-blue-0 text-black duration-300 cursor-pointer">
            اعتبار <span className=" text-[12px]">(دریافت کد تخفیف با اعتبار)</span>
          </a>
        </Link>
        <div>{faNumber(user?.score_credit.toLocaleString())}</div>
      </div>

      <div className="flex justify-between mb-3">
        <div className="text-[14px]">{fa.account.walletAmount}</div>
        <div className="flex">
          <div>{faNumber(Number(user?.price).toLocaleString())}</div>
          <PlusOutlined
            className="text-[18px] mr-[4px] mt-[2px] cursor-pointer hover:text-blue-10 duration-300"
            onClick={(): void => {
              setIsModalVisible('mobile');
              dispatch(
                postProfileAction(null, {
                  data: { next: 'chargeWallet' },
                  ok: true,
                }),
              );
            }}
          />
        </div>
      </div>

      {user?.mobile && user?.mobile !== '09' && (
        <div className="flex justify-between mb-3">
          <div>{fa.global.phoneNumber}</div>
          <div>
            {faNumber(user?.mobile)}
            <EditOutlined
              className="text-[14px] mr-[10px] cursor-pointer hover:text-blue-10 duration-300"
              onClick={(): void => {
                setIsModalVisible('mobile');
                dispatch(
                  postProfileAction(null, {
                    data: { next: 'newMobile' },
                    ok: true,
                  }),
                );
              }}
            />
          </div>
        </div>
      )}

      {user?.email && (
        <div className="flex text-[14px] justify-between flex-wrap mb-3">
          <div>{fa.global.email}</div>
          <span>
            <AntTooltip name={user.email || ''} length={18} />
          </span>
        </div>
      )}

      <button
        className="flex cursor-pointer hover:text-blue-10 duration-300 w-fit"
        type="button"
        onClick={(): void => setChangePasswordModal(true)}
      >
        <div className="text-[14px] mb-3">{fa.account.changePassword}</div>
        <EditOutlined className="text-[16px] mr-[10px] " />
      </button>
      <button
        className="flex cursor-pointer hover:text-blue-10 duration-300"
        type="button"
        onClick={(): void => setIsModalVisible('info')}
      >
        <div className="text-[14px] mb-3">{fa.account.editInfo}</div>

        <EditOutlined className="text-[16px] mr-[10px] " />
      </button>

      <Transaction />
      <MyQuestions />
      <MyTraining />
      <MyComments />
      <Link href={UserConsultingRoute()}>
        <a className="cursor-pointer text-gray-9 hover:text-blue-0 mb-3">مشاوره‌های من</a>
      </Link>

      <Link href={TicketRoute()}>
        <a className="cursor-pointer text-gray-9 hover:text-blue-0 mb-3">
          {fa.account.support}
        </a>
      </Link>
      <Link href={InstallmentsRoute()}>
        <a className="cursor-pointer text-gray-9 hover:text-blue-0 mb-3">پرداخت اقساط</a>
      </Link>
      {user?.can_create_exam_question && <MyCreateQuestion />}
      <ChangePassword visible={changePasswordModal} setVisible={setChangePasswordModal} />
    </div>
  );
};

export default UserInfo;
